import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Окружающий мир. 3-4 класс",
        subject: "Объекты Всемирного культурного наследия в России и за рубежом",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Неорганические и органические вещества растения.",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Виноградова Наталья Федоровна",
                grade: "д.пед.н., профессор",
                subGrade: "член-корр. РАО",
                imageSrc: "./images/author_1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    paragraphs: [
                        "В представленном кейсе обсуждаются цели, содержание и методические основы изучения одной из самых\n" +
                        "сложных тем программы учебного предмета «Окружающий мир» – «Объекты Всемирного культурного\n" +
                        "наследия в России и за рубежом».",
                        "Сложность её понимания связана с тем, что у младших школьников нет сформированных географических,\n" +
                        "исторических, культуроведческих знаний, которые помогли бы им установить соответствующие связи при\n" +
                        "оценке объектов природы и культуры, которые имеют мировое значение и отражают определенную\n" +
                        "историческую и социальную эпоху конкретной страны мира.",
                        "Восприятие детей ограничивается внешней, часто формальной стороной объекта и базируется на\n" +
                        "эмоциональных реакциях от увиденной величины, формы, необычной конструкции. Поэтому задача учителя –\n" +
                        "подвести младших школьников к осознанию мирового культурного опыта по созданию и, главное,\n" +
                        "сохранению объектов природы и культуры, которые сейчас принадлежат культурному наследию мира.",
                        "Поэтому задача учителя – подвести младших школьников к осознанию мирового культурного опыта по созданию" +
                        " и, главное, сохранению объектов природы и культуры, которые сейчас принадлежат культурному наследию мира."
                    ]
                },
                {
                    type: "table",
                    title: "Учебый предмет",
                    text: "Окружающий мир"
                },
                {
                    type: "table",
                    title: "Класс",
                    text: "3-4"
                },
                {
                    type: "table",
                    title: "Тема",
                    subtitle: "(место в разделе)",
                    text: "«Объекты Всемирного культурного наследия в России и за рубежом»"
                },
                {
                    type: "table",
                    title: "Цель кейса",
                    text: "Представить эффективную методику изучения в начальной школе объектов\n" +
                        "природы и культуры, которые вошли в список Всемирного культурного наследия\n" +
                        "ЮНЕСКО"
                },
                {
                    type: "table",
                    title: "Планируемые результаты",
                    subtitle: "(для педагога)",
                    unorderedList: [
                        "совершенствовать педагогическое мастерство учителя: готовность педагога\n" +
                        "к предупреждению трудностей изучения сложных тем программы предмета\n" +
                        "«Окружающий мир»;",
                        "привлечь внимание учителя к необходимости соотносить методику\n" +
                        "обучения с особенностями изучаемых объектов, с направленностью\n" +
                        "программной темы на личностное развитие ученика;",
                        "совершенствовать способность педагога к педагогической рефлексии."
                    ]
                },
                {
                    type: "table",
                    title: "Планируемые результаты",
                    subtitle: "(для обучающихся)",
                    children: [
                        {
                            type: "table",
                            listLabel: "Личностные:",
                            unorderedList: [
                                "проявлять эмоциональное отношение и интерес к объектам природы и\n" +
                                "социальной сферы, которые имеют мировое значение для сохранения\n" +
                                "культурного наследия;",
                                "выполнять правила ведения учебного диалога, совместной коммуникативной и художественной деятельности;"
                            ]
                        },
                        {
                            type: "table",
                            listLabel: "Метапредметные:",
                            unorderedList: [
                                "определять значение объекта природы (культуры) как объекта мирового культурного наследия;",
                                "сравнивать объекты природы и культуры, характеризовать их художественные достоинства;",
                                "описывать природные и культурные объекты России и мира, входящие в список Всемирного наследия ЮНЕСКО.",
                            ]
                        },
                        {
                            type: "table",
                            listLabel: "Предметные:",
                            unorderedList: [
                                "приводить примеры природных и культурных объектов России, вошедших в список Всемирного наследия;",
                                "характеризовать объект природы и социума с точки зрения его значения для мировой культуры;",
                                "соотносить объект природы или культуры со страной (континентом) его нахождения.",
                            ]
                        },
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 1",
            imagePath: "",
            id: "11",
            videoUrl: "./video/method-1_1.mp4"
        },
        {
            order: 3,
            type: PageType.PRACTICAL_MODULE,
            title: "Практический модуль. Часть 1",
            imagePath: "",
            id: "1",
            steps: [
                {
                    step: 0,
                    prevBtnName: "Далее",
                    nextBtnName: "Назад",
                    text: `
           Посмотрите видеофрагмент начала урока на тему «Знакомимся с объектами Всемирного наследия мира»,
           проанализируйте его и ответьте себе на два вопроса:
          `,
                    questions: [
                        "Каков уровень описаний, которые составляют дети (высокий, удовлетворительный, низкий)?",
                        "Решает ли учитель задачу постановки мотива урока?"
                    ],
                    audioUrl: "./audio/practice-1_1.mp3",
                    videoUrl: "./video/practice-1_1.mp4"
                },
                {
                    step: 1,
                    prevBtnName: "Далее",
                    nextBtnName: "Назад",
                    text: `
           Посмотрите видеофрагмент начала урока на тему «Знакомимся с объектами Всемирного наследия мира»,
           проанализируйте его и ответьте себе на два вопроса:
          `,
                    questions: [
                        "Каков уровень описаний, которые составляют дети (высокий, удовлетворительный, низкий)?",
                        "Решает ли учитель задачу постановки мотива урока?"
                    ],
                    imagePath: "./images/girl_1.png",
                    additionalText: "Ответы на данные вопросы вы найдёте в продолжении методического кейса"
                },
                {
                    step: 2,
                    prevBtnName: "Далее",
                    nextBtnName: "Назад",
                    text: "Посмотрите видеофрагмент основной части урока на тему «Знакомимся с объектами Всемирного\n" +
                        "наследия мира». Ответьте себе на следующие вопросы:",
                    questions: [
                        "Какие методы применяет учитель для ознакомления с новым объектом?",
                        "Выполнена ли цель урока: поняли ли дети уникальность египетских пирамид как объекта\n" +
                        "Всемирного наследия?",
                        "Какие бы советы вы дали учителю, который проводил урок?"
                    ],
                    audioUrl: "./audio/practice-1_2.mp3",
                    videoUrl: "./video/practice-1_2.mp4"
                },
                {
                    step: 3,
                    prevBtnName: "Далее",
                    nextBtnName: "Назад",
                    imagePath: "./images/old_man_1.png",
                    text: "Урок построен на основе репродуктивных заданий, которые строятся на основе восприятия и\n" +
                        "запоминания. Активные формы учебной деятельности не представлены."
                }
            ]
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 2",
            imagePath: "",
            id: "3",
            videoUrl: "./video/method-2_1.mp4"
        },
        {
            order: 5,
            type: PageType.PRACTICAL_MODULE,
            title: "Практический модуль. Часть 2",
            imagePath: "",
            id: "2",
            steps: [
                {
                    step: 0,
                    prevBtnName: "Далее",
                    nextBtnName: "Назад",
                    text:
                        "Есть два мнения по поводу того, целесообразно ли использовать фольклорный материал при\n" +
                        "изучении сложных тем или нет.",
                    opinions: [
                        {
                            text: "Мнение первое",
                            paragraphs: [
                                "При изучении сложных тем курса «Окружающий мир» нельзя использовать\n" +
                                "фольклорные произведения: легенды, былины, притчи, которые дают неверные представления о\n" +
                                "реальном объекте действительности.",
                                "При опросе дети начинают путать фантастику с реальностью и допускают ошибки в описании\n" +
                                "объекта, истории его создания. Пусть фольклор изучают только на уроках литературного чтения."
                            ]
                        },
                        {
                            text: "Мнение второе",
                            paragraphs: [
                                "При изучении сложных тем курса «Окружающий мир» младшие школьники\n" +
                                "не проявляют познавательного интереса к достаточно абстрактным, непонятным по\n" +
                                "терминологии учебным материалам.",
                                "Иллюстративный материал в этом случае тоже не всегда\n" +
                                "помогает. А вот легенды, мифы, небылицы напоминают детям сказки, которые они любят с\n" +
                                "самого раннего детства.",
                                "Ребята чётко различают реальность и фантастику, что позволяет им точно выделять реальные\n" +
                                "особенности объекта. При этом резко повышается мотивация ознакомления с ним, желание\n" +
                                "узнать, какой он на самом деле, а не в легенде или в мифе."
                            ]
                        }
                    ],
                    audioUrl: "./audio/practice-2_1.mp3",
                    additionalText: "Запишите свою точку зрения, а затем посмотрите и проанализируйте фрагмент урока, где\n" +
                        "используется легенда.",
                    additionalAudioUrl: "./audio/practice-2_2.mp3"
                },
                {
                    step: 1,
                    prevBtnName: "Далее",
                    nextBtnName: "Назад",
                    videoUrl: "./video/practice-2_1.mp4",
                },
                {
                    step: 2,
                    prevBtnName: "Далее",
                    nextBtnName: "Назад",
                    text: "Изменили ли вы свое мнение об использовании фольклора при ознакомлении младших школьников" +
                        " с объектами культурного мирового наследия?",
                    audioUrl: "./audio/practice-2_3.mp3",
                    imagePath: "./images/girl_2.png"
                },
                {
                    step: 3,
                    prevBtnName: "Далее",
                    nextBtnName: "Назад",
                    videoUrl: "./video/practice-2_2.mp4"
                }
            ]
        },
        {
            order: 6,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                  {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                 {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                 {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Попов А. Тайны египетских пирамид. – Москва: АСТ; Санкт-Петербург: Астрель-СПб, 2009",
                "Скляров А. Пирамиды: загадки строительства и назначения. – Москва: Вече, 2013",
                "Веденин Ю.А., Лютый А. А. и др. Культурное и природное наследие России. – Москва:Наука, 2012",
                "Виноградова Н.Ф. Изучение темы «Объекты Всемирного культурного наследия в России и за рубежом» в курсе «Окружающий мир» /Начальное образование, 2023",
                "Максаковский В.П. Всемирное культурное наследие: Научно-популярное справочное издание – Москва: Логос, 2000"
            ],
            filesToDownload: [
                {
                    link: "./files/biology_material.pdf",
                    fileName: "Лабораторная работа"
                }
            ]
        }
    ],
};
